import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FuseLoading from '@fuse/core/FuseLoading';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import handleError from '@fuse/core/errorHandler';
import ConfirmDeleteModalWindow from 'app/shared-components/confirmDeleteModalWindow';
import { useDeleteEmojiMutation, useGetAllEmojisQuery } from 'src/app/services/emojiApi';
import EmojisForm from './EmojisForm';
import { getAbsoluteFileUrl } from 'src/app/helpers/utils';

const Emojis = () => {
  const { t } = useTranslation('translations');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isOpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentEmoji, setCurrentEmoji] = useState(null);
  const { data: emojis, isLoading, refetch } = useGetAllEmojisQuery();

  const [deleteEmoji] = useDeleteEmojiMutation();

  const addNewEmoji = () => {
    setCurrentEmoji(null);
    setIsDialogOpen(true);
  };

  const handleEdit = (emoji) => {
    setCurrentEmoji(emoji);
    setIsDialogOpen(true);
  };

  const handleSelectedItemForDelete = (selectItem) => {
    setSelectedItem(selectItem);
    setOpenDeleteModal(true);
  };

  const handleDeleteEmoji = async ({ id }) => {
    try {
      await deleteEmoji({ id }).unwrap();
      setOpenDeleteModal(false);
      refetch();
    } catch (err) {
      handleError(err);
    }
  };

  if (isLoading) return <FuseLoading />;

  return (
    <div style={{ display: 'grid' }}>
      <TableContainer>
        <div className="h-[40px] flex flex-row justify-between dark:bg-dark">
          <h2 className="ml-5">{t('Emojis')}</h2>
          <Button
            className="mx-8"
            size="small"
            variant="outlined"
            color="secondary"
            onClick={addNewEmoji}
          >
            <FuseSvgIcon size={20}>react-outline:plus</FuseSvgIcon>
            <span className="mx-8">{t('Add')}</span>
          </Button>
        </div>
        <Table style={{ overflow: 'auto' }}>
          <TableHead>
            <TableRow className="dark:bg-dark">
              <TableCell>{t('Title')}</TableCell>
              <TableCell>{t('Emoji')}</TableCell>
              <TableCell>{t('Actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="min-h-[1000px] overflow-y-auto">
            {emojis?.map((item) => (
              <TableRow key={item.id} className="bg-white dark:bg-dark hover:bg-grey-200">
                <TableCell>{item.name}</TableCell>
                <TableCell>
                  <img src={getAbsoluteFileUrl(item.filePath)} className="w-20 h-20" />
                </TableCell>
                <TableCell component="td" scope="row">
                  <Tooltip className="cursor-pointer" placement="top" arrow title={t('Edit')}>
                    <EditIcon
                      onClick={() => {
                        handleEdit(item);
                      }}
                      edge="end"
                      aria-label="edit"
                      className="mr-5"
                      color="info"
                    />
                  </Tooltip>
                  <Tooltip className="cursor-pointer" title={t('Delete')} placement="top" arrow>
                    <DeleteIcon
                      onClick={() => handleSelectedItemForDelete(item)}
                      edge="end"
                      aria-label="edit"
                      className="mr-5"
                      color="error"
                    />
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <EmojisForm
        refetch={refetch}
        emoji={currentEmoji}
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        setCurrentEmoji={setCurrentEmoji}
      />
      {isOpenDeleteModal && (
        <ConfirmDeleteModalWindow
          onClose={() => setOpenDeleteModal(false)}
          open={isOpenDeleteModal}
          setIsOpenModal={setOpenDeleteModal}
          modalTitle={t('AreYouSureToDeleteEmoji')}
          deleteMessage={() => handleDeleteEmoji(selectedItem)}
        />
      )}
    </div>
  );
};

export default Emojis;
